import { render } from "./UploadPhoto.vue?vue&type=template&id=f089d7c6&scoped=true"
import script from "./UploadPhoto.vue?vue&type=script&lang=js"
export * from "./UploadPhoto.vue?vue&type=script&lang=js"

import "./UploadPhoto.vue?vue&type=style&index=0&id=f089d7c6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f089d7c6"],['__file',"resources/js/modules/product-mapping/components/UploadPhoto.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f089d7c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f089d7c6', __exports__)) {
    api.reload('f089d7c6', __exports__)
  }
  
  module.hot.accept("./UploadPhoto.vue?vue&type=template&id=f089d7c6&scoped=true", () => {
    api.rerender('f089d7c6', render)
  })

}


export default __exports__